import React, { useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap'

import { Modal } from '../../../components/Modal/Modal'

export interface UpdateSystemDocumentTypeModalProps {
  show: boolean
  onConfirm: (newName?: string) => void
  onCancel: () => void
  documentTypeName: string
}

export const UpdateSystemDocumentTypeModal: React.FC<UpdateSystemDocumentTypeModalProps> = ({ show, onConfirm, onCancel, documentTypeName }) => {
  const [newDocumentTypeName, setNewDocumentTypeName] = useState<string>(documentTypeName)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewDocumentTypeName(e.currentTarget.value)
  }

  return (
    <Modal
      show={show}
      onHide={onCancel}
      header={<></>}
      body={<UpdateSystemDocumentTypeModalBody documentTypeName={newDocumentTypeName} onChange={handleChange} />}
      showFooterActions={true}
      onFooterPrimaryAction={() => onConfirm(newDocumentTypeName)}
      footerPrimaryActionTitle='Save as New Document Type'
      footerPrimaryActionButtonVariant='primary'
      footerPrimaryActionDisabled={!newDocumentTypeName}
    />
  )
}

interface UpdateSystemDocumentTypeModalBodyProps {
  documentTypeName: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const UpdateSystemDocumentTypeModalBody: React.FC<UpdateSystemDocumentTypeModalBodyProps> = ({ documentTypeName, onChange }) => {
  return (
    <Container>
      <Row className='pb-3'>
        <Col>
          <h4 className='d-flex justify-content-center align-items-center'>Update System Document Type</h4>
        </Col>
      </Row>
      <Row className=''>
        <Col className='p-0'>
          <div className='paragraph-medium mb-3'>System document types cannot be changed. Would you like to create a new document type?</div>
          <div className='lead-small'>New Document Type Name</div>
          <Form.Control type='text' value={documentTypeName} onChange={onChange} placeholder='Enter a name…' />
        </Col>
      </Row>
    </Container>
  )
}
